exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".placeBetween[data-v-0d2d1966]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;padding-bottom:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}.placeBetween>div[data-v-0d2d1966]{cursor:pointer;color:#1d323a}hr[data-v-0d2d1966]{border:none;border-bottom:1px solid #ccc;width:100%}.padLeft[data-v-0d2d1966]{padding-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d2d1966","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/questions/QuestionDetails.vue
// module id = 802
// module chunks = 0